
 
//  document.addEventListener('click', function (event) {
//   const btn = event.target.closest('.variant-thumb');
//   if (!btn) return;

//   const wrapper = btn.closest('.variant-thumbs-wrapper');
//   if (!wrapper) return;

//   const value = btn.dataset.colorValue;
//   const optionName = wrapper.dataset.optionName;

//   if (!value || !optionName) return;

//   // Update label text: Color: Matte Black
//   const current = wrapper.querySelector('.variant-thumbs-current');
//   if (current) {
//     current.textContent = value;
//   }

//   // Visual active state
//   wrapper.querySelectorAll('.variant-thumb').forEach(function (el) {
//     el.classList.toggle('variant-thumb--active', el === btn);
//   });

//   // Click the real variant picker input so Shopify/Impulse handles variant + image update
//   const realInputs = document.querySelectorAll(
//     'input[type="radio"][name="options[' + optionName + ']"]'
//   );

//   let realInput = null;

//   realInputs.forEach(function (input) {
//     if (input.value === value) {
//       realInput = input;
//     }
//   });

//   if (realInput) {
//     realInput.click();

//     // extra safety: trigger change also
//     realInput.dispatchEvent(new Event('change', { bubbles: true }));
//   } else {
//     console.warn('Matching real variant input not found for:', value);
//   }
// });

 document.addEventListener('DOMContentLoaded', function () {
    let isSyncingThumb = false;
    function syncVariantThumbWithRadio(input) {
      if (!input || isSyncingThumb) return;
      const value = input.value;
      if (!value) return;
      const form = input.closest('form') || document;
      const matchingThumb = form.querySelector(
        '.variant-thumb[data-color-value="' + CSS.escape(value) + '"]'
      );
      if (!matchingThumb) {
        console.warn('Matching variant thumb not found for:', value);
        return;
      }

      isSyncingThumb = true;

      matchingThumb.click();

      setTimeout(function () {
        isSyncingThumb = false;
      }, 100);
    }

    document.addEventListener('change', function (event) {
      const input = event.target;
      if ( input.matches('input[type="radio"][name^="Color"], input[type="radio"][data-variant-input]') ) {
        syncVariantThumbWithRadio(input);
        const  framecolor = input.getAttribute('frame-color');
         const  lenscolor = input.getAttribute('lens-color') 
          const  framematerial = input.getAttribute('frame-material');
           const  vweight = input.getAttribute('variant-weight');
          
          if(framecolor){
                document.querySelector('.variant-specifications li.frame-color span').textContent = framecolor;
          }else{
            document.querySelector('.variant-specifications li.frame-color').style.display = 'none';
          }
           if(lenscolor){
                document.querySelector('.variant-specifications li.lens-color span').textContent = lenscolor;
          }else{
            document.querySelector('.variant-specifications li.lens-color').style.display = 'none';
          }
           if(framematerial){
                document.querySelector('.variant-specifications li.frame-material span').textContent = framematerial;
          }else{
            document.querySelector('.variant-specifications li.frame-material').style.display = 'none';
          }
          if(vweight){
                document.querySelector('.variant-specifications li.weight span').textContent = vweight;
          }else{
            document.querySelector('.variant-specifications li.weight').style.display = 'none';
          }
      }
    });

    // Page load pe checked radio ke according thumb active karna
    const checkedColorInput = document.querySelector(
      'input[type="radio"][name^="Color"]:checked, input[type="radio"][data-variant-input]:checked'
    );

    if (checkedColorInput) {
      syncVariantThumbWithRadio(checkedColorInput);
    }
  });
